import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type ChainItem = Record<string, string | null | undefined>;

interface ChainState {
  chain: ChainItem[];
  addToLast: (item: ChainItem) => void;
  removeFromLast: () => ChainItem | null;
  clearChain: () => void;
}

const useChainStore = create<ChainState>()(
  devtools(
    (set, get) => ({
      chain: [],
      addToLast: (item) => set((state) => ({ chain: [...state.chain, item] })),
      removeFromLast: () => {
        const currentChain = get().chain;

        if (currentChain.length === 0) {
          return null;
        }

        const lastItem = currentChain.at(-1) ?? null;
        set({ chain: currentChain.slice(0, -1) });

        return lastItem;
      },

      clearChain: () => set({ chain: [] }),
    }),
    { name: 'ChainStore' }
  )
);

export default useChainStore;
